import React, { useMemo, useState } from "react";
import { MdPreview } from "md-editor-rt";
import { Collapse, message } from "antd";
import { ReactComponent as LineIcon } from "../static/line_icon.svg";
import downIcon from "../static/down.svg";
import deepseekThinkIcon from "../static/deepseek_think.svg";
import "md-editor-rt/lib/style.css";
import { useTranslation } from "../i18n";
// import "md-editor-rt/lib/preview.css";
import FileItem from "./fileitem";
import "./theme.css";

interface Props {
  className?: string;
  props: any;
}
const Markdown: React.FC<Props> = ({ props }) => {
  const { t } = useTranslation();
  console.log("🚀 ~ Markdown ~ props:", props);
  const [id] = useState("preview-only");
  const [refTextHeight, setRefTextHeight] = useState<boolean>(false);

  return (
    <>
      {props.role === "user" ? (
        <div className="flex justify-end ">
          {props.content &&
            !props.prompts &&
            !props.refText &&
            (!props.fileList || props?.fileList?.length === 0) && (
              <p className="bg-[rgb(238,241,255)] rounded-[8px] px-[12px] py-[6px] w-auto whitespace-pre-wrap text-theme">
                {props.content}123456789
              </p>
            )}

          {props.prompts && (
            <div className="max-w-full flex flex-col items-end">
              <div className="bg-[#EEF1FF] w-[fit-content] rounded-[8px] float-right p-[6px] my-[14px] max-w-full flex items-center gap-[4px] ">
                {props?.prompts?.icon && (
                  <img
                    src={props?.prompts?.icon}
                    className="w-[14px] h-[14px]"
                  />
                )}
                <p className="m-0 text-[14px] text-[#000000f5]">
                  {props?.prompts?.content}
                </p>
              </div>
              {props.prompts.type === "image" ? (
                <div className="flex justify-end max-w-full flex-wrap gap-[6px]">
                  {props.prompts.fileList.map((item: any, index: number) => {
                    return (
                      <div
                        key={index}
                        className="max-h-[128px] max-w-[346px] relative group gap-[6px]"
                      >
                        <img
                          src={item.url}
                          className="max-h-[128px] max-w-[346px]"
                          alt=""
                          style={{
                            border: "1px solid #e6e6e6",
                            padding: "4px",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : props.prompts.type === "file" ? (
                <div className="flex max-w-full flex-wrap  gap-[6px] justify-end">
                  {props.prompts.fileList.map((file: any, index: number) => {
                    const fileExtension = file?.name?.split(".").pop() || "";
                    if (
                      [
                        "doc",
                        "docx",
                        "xls",
                        "xlsx",
                        "ppt",
                        "pptx",
                        "txt",
                        "pdf",
                      ].includes(fileExtension)
                    ) {
                      return (
                        <FileItem
                          key={index}
                          url={file.url}
                          fileName={file.name}
                          fileType={fileExtension}
                          img_obj={file}
                          isMessage={true}
                          onGetItem={() => {
                            // urlTofile(file);
                          }}
                        />
                      );
                    }
                    return null; // 如果不符合条件，返回 null
                  })}
                </div>
              ) : props.prompts.refText ? (
                <div
                  className={`px-[12px] py-[10px] min-h-[40px] max-w-[250px] w-[fit-content]  rounded-[8px] overflow-hidden  cursor-pointer   hover:!border-[#72768b52]`}
                  style={{
                    border: "1px solid #72768b29",
                    height: refTextHeight ? "auto" : "40px",
                  }}
                  onClick={() => {
                    setRefTextHeight((pre: boolean) => {
                      return !pre;
                    });
                  }}
                >
                  <p
                    className={`m-0  w-[100%] text-[#0a0d3373] text-[12px] ${
                      !refTextHeight &&
                      "text-ellipsis whitespace-nowrap  overflow-hidden "
                    }`}
                  >
                    {props.prompts.refText}
                  </p>
                </div>
              ) : null}
            </div>
          )}
          {props.summarizeInfo && !props.prompts && (
            <div className="flex justify-end flex-col items-end gap-[14px]">
              {props.summarizeInfo &&
                !props.prompts &&
                !props.refText &&
                !props.content &&
                (!props.fileList || props?.fileList?.length === 0) && (
                  <div className=" flex gap-[4px] bg-[rgb(238,241,255)] rounded-[8px] px-[12px] py-[6px] w-auto whitespace-pre-wrap text-theme items-center justify-center">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.61734 3.9145C6.69239 3.63443 6.98026 3.46822 7.26033 3.54327L10.4157 4.38874C10.6958 4.46379 10.862 4.75166 10.7869 5.03173C10.7119 5.3118 10.424 5.47801 10.1439 5.40297L6.98857 4.55749C6.7085 4.48244 6.5423 4.19457 6.61734 3.9145Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M6.76097 6.30823C6.4809 6.23319 6.19302 6.39939 6.11798 6.67946C6.04293 6.95953 6.20914 7.24741 6.48921 7.32246L8.29227 7.80558C8.57234 7.88063 8.86022 7.71442 8.93526 7.43435C9.01031 7.15428 8.8441 6.86641 8.56403 6.79136L6.76097 6.30823Z"
                        fill="currentColor"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.2912 1.2068L9.07575 0.881138C8.52615 0.733868 8.08286 0.615084 7.71603 0.548226C7.33833 0.479388 6.99659 0.456201 6.65522 0.52876C6.11299 0.644015 5.62116 0.92797 5.25024 1.33993C5.01671 1.59928 4.86593 1.90683 4.73669 2.26835C4.64852 2.51499 4.56368 2.80711 4.46995 3.14961L3.53652 3.39973C2.98692 3.54699 2.54362 3.66576 2.19251 3.79128C1.83099 3.92051 1.52344 4.0713 1.26409 4.30482C0.852134 4.67575 0.568179 5.16758 0.452924 5.70981C0.380364 6.05117 0.403552 6.39292 0.47239 6.77062C0.539247 7.13745 0.658031 7.58074 0.805301 8.13034L1.41466 10.4045C1.56192 10.9541 1.68069 11.3974 1.80621 11.7485C1.93544 12.11 2.08623 12.4176 2.31975 12.6769C2.69068 13.0889 3.18251 13.3728 3.72474 13.4881C4.06611 13.5606 4.40785 13.5375 4.78555 13.4686C5.15237 13.4018 5.59564 13.283 6.14521 13.1357L7.13523 12.8704C7.68486 12.7232 8.12817 12.6044 8.4793 12.4789C8.84082 12.3496 9.14837 12.1989 9.40772 11.9653C9.66074 11.7375 9.86546 11.4641 10.0125 11.1614C10.0567 11.1551 10.1009 11.1473 10.1451 11.1379C10.6873 11.0227 11.1791 10.7387 11.55 10.3268C11.7836 10.0674 11.9344 9.75988 12.0636 9.39836C12.1891 9.0473 12.3078 8.60408 12.4551 8.05458L13.0224 5.9374C13.1696 5.38782 13.2884 4.94452 13.3553 4.57769C13.4241 4.19999 13.4473 3.85825 13.3748 3.51689C13.2595 2.97466 12.9755 2.48283 12.5636 2.1119C12.3042 1.87838 11.9967 1.72759 11.6352 1.59836C11.284 1.47284 10.8408 1.35406 10.2912 1.2068ZM8.81936 11.0646L8.82425 11.0656C8.78683 11.1074 8.74709 11.1473 8.70513 11.185C8.58981 11.2889 8.42602 11.3829 8.12585 11.4902C7.81989 11.5995 7.41821 11.7076 6.84182 11.862L5.89522 12.1157C5.31883 12.2701 4.91694 12.3774 4.59728 12.4356C4.28367 12.4928 4.09483 12.4933 3.94305 12.461C3.61771 12.3919 3.32261 12.2215 3.10006 11.9743C2.99622 11.859 2.90224 11.6952 2.79493 11.3951C2.68556 11.0891 2.57751 10.6874 2.42306 10.111L1.82534 7.88029C1.6709 7.3039 1.56363 6.902 1.50537 6.58235C1.44822 6.26874 1.44772 6.0799 1.47998 5.92812C1.54913 5.60278 1.7195 5.30768 1.96668 5.08513C2.082 4.98129 2.24579 4.88731 2.54596 4.78C2.85192 4.67063 3.2536 4.56258 3.82999 4.40813L4.15522 4.32099L3.77787 5.72929C3.6306 6.27887 3.51182 6.72218 3.44496 7.089C3.37612 7.4667 3.35293 7.80844 3.42549 8.14981C3.54075 8.69204 3.8247 9.18387 4.23666 9.5548C4.43118 9.72995 4.65282 9.85855 4.90401 9.96643C4.98772 10.0024 5.07471 10.036 5.16508 10.0683C5.51617 10.1938 5.95957 10.3127 6.50911 10.4599L7.72455 10.7856L7.77566 10.7993C8.17023 10.9051 8.51385 10.9972 8.81936 11.0646ZM8.81936 11.0646L7.72455 10.7856L5.16508 10.0683L8.81936 11.0646ZM9.6711 10.132C9.77154 10.1344 9.85346 10.1265 9.92675 10.1109C10.2521 10.0417 10.5472 9.87137 10.7697 9.62419C10.8736 9.50887 10.9676 9.34508 11.0749 9.04491C11.1842 8.73895 11.2923 8.33727 11.4467 7.76088L12.0023 5.68736C12.1568 5.11098 12.264 4.70908 12.3223 4.38942C12.3795 4.07582 12.38 3.88698 12.3477 3.73519C12.2785 3.40985 12.1082 3.11476 11.861 2.8922C11.7457 2.78837 11.5819 2.69438 11.2817 2.58708C10.9758 2.47771 10.5741 2.36965 9.99769 2.21521L8.8257 1.90118C8.24931 1.74673 7.84742 1.63947 7.52776 1.58121C7.21415 1.52405 7.02531 1.52355 6.87353 1.55581C6.54819 1.62497 6.2531 1.79534 6.03054 2.04252C5.92671 2.15783 5.83272 2.32163 5.72542 2.62179C5.61604 2.92775 5.50799 3.32944 5.35355 3.90582L4.79795 5.97934C4.6435 6.55573 4.53624 6.95763 4.47798 7.27728C4.42082 7.59089 4.42032 7.77973 4.45259 7.93151C4.52174 8.25685 4.69211 8.55195 4.93929 8.7745C5.0263 8.85285 5.1409 8.92558 5.32086 9.00267C5.3645 9.02136 5.41199 9.04031 5.46386 9.05966C5.48158 9.06626 5.49981 9.07292 5.51857 9.07963C5.8054 9.18216 6.17637 9.28354 6.69655 9.42307L6.80255 9.45148L9.6711 10.132ZM9.64681 10.1313C9.65294 10.1315 9.65904 10.1317 9.6651 10.1319L9.6711 10.132L9.64681 10.1313ZM9.64681 10.1313C9.54423 10.1272 9.42268 10.1129 9.27252 10.0855C9.20234 10.0727 9.12819 10.0576 9.0491 10.0401L9.64681 10.1313Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <p className=" flex justify-center items-center !m-0">
                      {t("summary")}
                    </p>
                  </div>
                )}
              <div className="p-2 border-[1px] border-[rgb(235, 237, 239)] border-solid flex overflow-hidden max-w-[187px] rounded-[5px]">
                <img
                  src={props.summarizeInfo.favIconUrl}
                  alt=""
                  className="w-[40px] h-[40px]"
                />
                <div className="flex-1 text-[12px] !text-[#333] overflow-hidden w-[200px] px-[4px] pt-[3px]">
                  <p className="m-0 truncate">{props.summarizeInfo.title}</p>
                  <p className="m-0 truncate">{props.summarizeInfo.url}</p>
                </div>
              </div>
            </div>
          )}
          {props.refText && !props.prompts && (
            <div className="flex justify-end flex-col items-end gap-[14px]">
              <p className="bg-[rgb(238,241,255)] rounded-[8px]  px-[12px] py-[6px] w-fit whitespace-pre-wrap text-theme">
                {props.content}
              </p>
              <div
                className={`px-[12px] py-[10px] min-h-[40px] max-w-[250px] w-[fit-content]  rounded-[8px] overflow-hidden  cursor-pointer   hover:!border-[#72768b52]`}
                style={{
                  border: "1px solid #72768b29",
                  height: refTextHeight ? "auto" : "40px",
                }}
                onClick={() => {
                  setRefTextHeight((pre: boolean) => {
                    return !pre;
                  });
                }}
              >
                <p
                  className={`m-0  w-[100%] text-[#0a0d3373] text-[12px] ${
                    !refTextHeight &&
                    "text-ellipsis whitespace-nowrap  overflow-hidden "
                  }`}
                >
                  {props.refText}
                </p>
              </div>
            </div>
          )}
          {props?.fileList?.length > 0 && (
            <div className="flex justify-end flex-col items-end gap-[14px]">
              <p className="bg-[rgb(238,241,255)] rounded-[8px]  px-[12px] py-[6px] w-fit whitespace-pre-wrap text-theme">
                {props.content}
              </p>
              <div className="flex gap-[10px] ">
                {props.fileList.map((item: any, index: number) => {
                  if (
                    ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(
                      item.name.split(".").pop()
                    )
                  ) {
                    return (
                      <div
                        key={index}
                        className="max-h-[128px] max-w-[346px] relative group gap-[6px]"
                      >
                        <img
                          src={item.url}
                          className="max-h-[128px] max-w-[346px]"
                          alt=""
                          style={{
                            border: "1px solid #e6e6e6",
                            padding: "4px",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <FileItem
                        key={index}
                        url={item.url}
                        fileName={item.name}
                        fileType={item.name.split(".").pop() || ""}
                        img_obj={item}
                        isMessage={true}
                        onGetItem={() => {
                          // urlTofile(file);
                        }}
                      />
                    );
                  }
                })}
              </div>
            </div>
          )}
        </div>
      ) : props?.imgUrlList ? (
        <div className="flex gap-[10px] max-w-[100%]">
          {!props.errorCode && !props.error && (
            <img
              src={props.modelLogo}
              alt={t("modelAvatar")}
              className="w-[30px] h-[30px]"
            />
          )}

          <div className="flex flex-col gap-[12px] overflow-hidden">
            <div>
              <p className="font-bold text-[#333333] text-[16px] h-[30px] leading-[30px]">
                {props.modelName}
              </p>
              <div className="p-[5px] rounded-[8px] flex justify-center items-center   gap-[12px] max-w-full">
                {props.imgUrlList.map((item: any) => {
                  return (
                    <img
                      src={item}
                      alt=""
                      className="min-w-[132px] min-h-[132px] rounded-[8px]  max-w-full"
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex gap-[10px] max-w-[100%]">
          {!props.errorCode && !props.error && (
            <img
              src={props.compareArray[props.arrNum || 0].modelLogo}
              alt={t("modelAvatar")}
              className="w-[30px] h-[30px]"
            />
          )}

          <div className="flex flex-col gap-[12px] overflow-hidden">
            {!props.errorCode && !props.error && (
              <div>
                <p className="font-bold text-[#333333] text-[16px] h-[30px] leading-[30px]">
                  {props.compareArray[props.arrNum || 0].modelName}
                </p>
              </div>
            )}

            {props.compareArray[props.arrNum || 0].searchResults &&
              props?.compareArray[props.arrNum || 0]?.searchResults?.length >
                0 && (
                <Collapse
                  ghost
                  items={[
                    {
                      key: "deep-searchResults",
                      label: (
                        <div className=" flex gap-[4px] group items-center mb-[8px]">
                          <LineIcon className="text-[#333333] w-[16px] h-[16px] group-hover:hidden" />
                          <img
                            src={downIcon}
                            alt=""
                            className="w-[16px] h-[16px]  hidden group-hover:flex"
                          />
                          <p className="m-0 text-[#0a0d3373] text-[14px] font-semibold group-hover:text-[#0a0d3399]">
                            {t("searchedWebpages", {
                              count:
                                props.compareArray[props.arrNum || 0]
                                  .searchResults?.length || 0,
                            })}
                          </p>
                        </div>
                      ),
                      className: "aiPreThink aiPreSearch",
                      children: (
                        <ul className="p-0 m-0  grid grid-cols-2 gap-x-[2%] gap-y-[8px] ">
                          {props.compareArray[
                            props.arrNum || 0
                          ].searchResults.map((item: any) => (
                            <li
                              key={item.index}
                              className="max-h-[26px] h-[26px] overflow-hidden flex bg-[#72768b0f] px-[12px] items-center gap-[4px] rounded-full cursor-pointer text-[12px] hover:bg-[#72768b1f]"
                              style={{
                                width: "100%",
                                maxWidth: "100%",
                              }}
                              onClick={() => {
                                // chrome.tabs.create({ url: item.url });
                                window.open(item.url, "_blank");
                              }}
                            >
                              {item.icon ? (
                                <img
                                  src={item.icon}
                                  className="w-[16px] h-[16px] mr-1 flex-shrink-0"
                                  alt={t("icon")}
                                />
                              ) : (
                                <LineIcon className="text-[#333333] w-[16px] h-[16px] mr-1 flex-shrink-0" /> // 固定图标尺寸
                              )}
                              <p className="m-0 text-ellipsis overflow-hidden whitespace-nowrap flex-grow">
                                {item.title}
                              </p>
                            </li>
                          ))}
                        </ul>
                      ),
                      showArrow: false,
                    },
                  ]}
                />
              )}
            {props.compareArray[props.arrNum || 0].deepThinkingContent && (
              <Collapse
                ghost
                items={[
                  {
                    key: "deep-think",
                    label: (
                      <div className=" flex gap-[4px] group items-center mb-[8px]">
                        <img
                          className="w-[16px] h-[16px] group-hover:hidden"
                          src={deepseekThinkIcon}
                          alt={t("icon")}
                        />
                        <img
                          src={downIcon}
                          className="w-[16px] h-[16px]  hidden group-hover:flex"
                          alt=""
                        />
                        <p className="m-0 text-[#0a0d3373] text-[14px] font-semibold group-hover:text-[#0a0d3399]">
                          {t("deepThinking", {
                            seconds: Math.ceil(
                              (props.compareArray[props.arrNum || 0]
                                .thinkingTimeEnd -
                                props.compareArray[props.arrNum || 0]
                                  .thinkingTimeStart) /
                                1000,
                            ),
                          })}
                        </p>
                      </div>
                    ),
                    className: "aiPreThink",
                    children: (
                      // <Markdown previewTheme="deep-think">
                      //   {item.deepThinkingContent}
                      // </Markdown>
                      <MdPreview
                        previewTheme={"deepThink"}
                        id="preview-only"
                        autoFoldThreshold={10000000}
                        value={
                          props.compareArray[props.arrNum || 0]
                            .deepThinkingContent
                        }
                      />
                    ),
                    showArrow: false,
                  },
                ]}
              />
            )}
            <MdPreview
              previewTheme={"text"}
              id={id}
              value={props.compareArray[props.arrNum || 0].content}
              autoFoldThreshold={10000000}
            ></MdPreview>
          </div>
        </div>
      )}
    </>
  );
};

export default Markdown;
